<template>
  <div class="course-ul">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item v-for="(item, index) in courses" :key="index" :title="item.name" :name="index">
        <template slot="title">
          <div class="course-title">{{ item.name }}</div>
        </template>
        <div class="course-content">
          <div class="course-item" v-for="(itemTwo, indexTwo) in item.list" :key="indexTwo" @click="gotoCourseDetails(itemTwo)">
            <div
              :class="['none', getWatchStatus(itemTwo).includes('观看至') ? 'partial' : '', getWatchStatus(itemTwo) === '已观看' ? 'watched' : '']">
              {{ getWatchStatus(itemTwo) }}
            </div>
            <div class="courseDurationFormat">{{ itemTwo.courseDurationFormat }}</div>
            <div class="course-img">
              <img v-if="itemTwo.image && itemTwo.image.url != undefined" :src="itemTwo.image.url" alt="课程封面" />
              <img v-if="!itemTwo.image" src="@/assets/images/logo-img.png" alt="">
            </div>
            <div class="course-text">
              <div class="course-time">{{ itemTwo.createTimeFormat }}</div>
              <div class="course-p">{{ itemTwo.title }}</div>
            </div>
          </div>
          <empty class="empty-margin" v-if="item.list <= 0"></empty>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import empty from "@/components/empty/index";
export default {
  name: "Course",
  components: { empty },
  data() {
    return {
      liveStatus: {
        END: "已结束",
        LIVING: "直播中",
        NOT_START: "未开始",
      },
      liveStatusClass: {
        END: "end",
        LIVING: "living",
        NOT_START: "not-start",
      },
      activeName: 0,
    };
  },
  props: {
    courses: {
      type: Array,
      required: true, // 父组件传递课程列表
    },
    isLiveStreaming: {
      type: String,
      default: "",
    },
  },
  methods: {
    getWatchStatus(course) {
      // 如果没有学习记录 或 duration 为 0
      if (!course.learningProgress || course.learningProgress.duration == 0) {
        return "未观看";
      }

      const watched = course.learningProgress.duration;
      const total = course.courseDurationFormat; // 假设格式是字符串，比如 "00:30:00"

      // 转换为秒数
      const timeToSeconds = (timeStr) => {
        const parts = timeStr.split(":").map(Number);
        if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          return parts[0] * 60 + parts[1];
        } else {
          return parseInt(timeStr); // 防止后端只给了秒数
        }
      };

      const totalSeconds = timeToSeconds(total);

      if (!totalSeconds || totalSeconds === 0) return "未观看";

      if (watched >= totalSeconds) {
        return "已观看";
      }

      const percent = Math.floor((watched / totalSeconds) * 100);
      return `观看至${percent}%`;
    },
    // 判断当前课程是否已经观看
    gotoCourseDetails(value) {
      // console.log(this.activeName, this.courses, 'activeName')
      this.$emit("gotoCourseDetails");
      this.$router.push({ path: `/CourseDetails/${value.id}` }); // 动态路由传递课程 id
    },
  },
};
</script>

<style scoped lang="less">
.course-ul {
  margin-top: 15px;

  .course-title {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    padding-left: 15px;
  }

  /deep/.el-collapse-item {
    margin-bottom: 10px !important;
    border-radius: 6px !important;
    overflow: hidden;
  }

  .course-content {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    padding: 0 14px;

    .course-item {
      width: calc(25% - 20px);
      position: relative;
      background: #fff;
      cursor: pointer;

      .courseDurationFormat {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #fff;
        background: rgba(0, 0, 0, .4);
        padding: 0 6px;
        display: flex;
        align-items: center;
        font-size: 14px;
        justify-content: center;
        height: 22px;
        line-height: 22px;
      }

      .course-img {
        width: 100%;
        height: 190px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          /* 保持比例填充并裁剪 */
          display: block;
        }
      }

      .none {
        position: absolute;
        left: 10px;
        top: 10px;
        background: #9C1D22;
        color: #fff;
        font-size: 14px;
        padding: 0 6px;
        height: 22px;
        line-height: 22px;
      }

      .course-text {
        padding: 16px;
        text-align: left;

        .course-time {
          font-size: 16px;
          line-height: 16px;
          color: #999999;
          margin-bottom: 12px;
        }

        .course-p {
          color: var(---, #222);
          font-size: 18px;
          line-height: 26px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/courseTwo.vue